import { BareActionContext } from 'vuex-typex'
import { StatementState } from '../state'
import { RootState } from '../..'
import statementStore from '../statement-store'
import setStatementQuery from './set-statement-query'

export default async function addSearchTag(context: BareActionContext<StatementState, RootState>)
{
    const form = statementStore.state.statementSearchForm
    if (form.tags.indexOf(form.tag) < 0) {
        form.tags.push(form.tag)
    }
    form.tag = ''
    setStatementQuery(context)

    return
}
